import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Attendance from './Screens/Attendance';
import AttendanceDetails from './Screens/AttendanceDetails';
import Timetable from './Screens/Timetable';
import Login from './Screens/Login';
import Home from './Screens/Home';
import Opening from './Screens/Opening';
import IdCard from './Screens/IdCard';
import Marks from './Screens/Marks';
import { BrowserRouter as Router, Route , BrowserRouter, Switch, useLocation } from "react-router-dom";
import * as serviceWorker from './serviceWorker';
import './Fonts/Raleway-Light.ttf';
import './Fonts/Raleway-ExtraLight.ttf';
import './Fonts/Raleway-Thin.ttf';
import './Fonts/Raleway-SemiBold.ttf';
import './Fonts/Raleway-Regular.ttf';
import './Fonts/Raleway-Bold.ttf';
import './Fonts/Raleway-Italic.ttf';
import './Fonts/Raleway-Medium.ttf';
import './Fonts/Raleway-ExtraBold.ttf';
import './Fonts/Raleway-ExtraLightItalic.ttf';
import './Fonts/Raleway-ThinItalic.ttf';

import './Fonts/Lato-Bold.ttf';
import './Fonts/Lato-Black.ttf';
import './Fonts/Lato-BoldItalic.ttf';
import './Fonts/Lato-Italic.ttf';
import './Fonts/Lato-Light.ttf';
import './Fonts/Lato-Regular.ttf';
import './Fonts/Lato-Thin.ttf';
import { AnimatePresence} from 'framer-motion';

ReactDOM.render(
  
  <Router history = {BrowserRouter}>
    <AnimatePresence >
      <Switch >
        <Route path = {"/"} exact component = {Opening}/>
        <Route path = {"/opening"} exact component = {Opening}/>
        <Route path = {"/home"} exact component = {Home}/>
        <Route path = {"/login"} exact component = {Login}/>
        <Route path = {"/timetable"} exact component = {Timetable}/>
        <Route path = {"/attendance"} exact component = {Attendance}/>
        <Route path = {"/attendanceDetails"} exact component = {AttendanceDetails}/>
        <Route path = {"/idCard"} exact component = {IdCard}/>
        <Route path = {"/marks"} exact component = {Marks}/>
      </Switch>
    </AnimatePresence>
  </Router>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
